import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import moment from 'moment';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import useTimeSlots from 'components/Common/Calendars/Hooks/useTimeSlots';

import Day from './Day';
import Slots from './Slots';
import SelectedTime from './SelectedTime';

export default function Index({ step, selectedTime, setSelectedTime }) {
  let selectedDayCurrent = null;
  let fullSelectedDayCurrent = null;
  if (selectedTime) {
    selectedDayCurrent = moment.parseZone(selectedTime).format('M.D');
    fullSelectedDayCurrent = selectedTime;
  }

  const [selectedDay, setSelectedDay] = useState(selectedDayCurrent);
  const [fullSelectedDay, setFullSelectedDay] = useState(fullSelectedDayCurrent);

  const [startDate, setStartDate] = useState(moment(selectedTime || new Date()).startOf('month'));

  const monthTimeSlots = useTimeSlots({ stepId: step.id, startDate });

  const validDate = (current) => {
    const yesterday = moment().subtract(1, 'day');
    const dayKey = current.format('M.D');

    return current.isAfter(yesterday) && monthTimeSlots && monthTimeSlots.slots[dayKey]?.length > 0;
  };

  const updateCalendarMonth = (value) => {
    setStartDate((currentValue) => moment(currentValue).add(value, 'M'));
  };

  return (
    <>
      <h5 className="mb-4 text-center">
        Select Date and Time
      </h5>

      <div className="d-flex gap-3">
        <div>
          {monthTimeSlots === null && (
            <LoadingPlaceholder className="calendar-loading" />
          )}
          {monthTimeSlots !== null && (
          <Datetime
            input={false}
            timeFormat={false}
            onBeforeNavigate={
          (_nextView, currentView, _viewDate) => currentView // to stay on a 'days' view
        }
            onNavigateBack={() => updateCalendarMonth(-1)}
            onNavigateForward={() => updateCalendarMonth(1)}
            renderDay={(props, currentDate) => (
              <Day
                props={props}
                currentDate={currentDate}
                selectedDay={selectedDay}
                setFullSelectedDay={setFullSelectedDay}
                setSelectedDay={setSelectedDay}
                setSelectedTime={setSelectedTime}
              />

            )}
            className="calendar"
            isValidDate={validDate}
            initialViewDate={startDate.toDate()}
            initialValue={selectedTime}
          />
          )}
        </div>

        <div style={{ width: '200px' }}>
          <Slots
            selectedDay={selectedDay}
            monthTimeSlots={monthTimeSlots}
            selectedTime={selectedTime}
            setSelectedTime={setSelectedTime}
          />
        </div>

      </div>

      <SelectedTime
        step={step}
        fullSelectedDay={fullSelectedDay}
        selectedTime={selectedTime}
        monthTimeSlots={monthTimeSlots}
      />

    </>
  );
}

Index.propTypes = {
  step: PropTypes.object.isRequired,
  selectedTime: PropTypes.instanceOf(Date),
  setSelectedTime: PropTypes.func.isRequired,
};

Index.defaultProps = {
  selectedTime: null,
};
